import { IdObject } from '../models/IdObject';
import { uniqueFilterRequest } from '.';
import { ISearchQueryRequest } from '../models/ISearchQueryRequest';

export const getAndUpdateRequestForFilter = (
  searchQuery: any,
  productStatusFilterParam: any,
  partStatusId: number,
  selection: boolean
) => {
  let updateRequest: ISearchQueryRequest = {
    ...searchQuery
  };

  let productStatusFilter: IdObject[] = productStatusFilterParam
    ? [...productStatusFilterParam]
    : [];
  let newFilterPartStatus: IdObject = {
    id: partStatusId.toString()
  };
  productStatusFilter = [...productStatusFilter, newFilterPartStatus];
  updateRequest = uniqueFilterRequest(
    updateRequest,
    productStatusFilter,
    'productStatusFilter',
    selection
  );

  return updateRequest;
};
